export default __webpack_public_path__ + "static/media/NL_parcours_1_carte_6.a0e282fd.png";